import React from 'react';

function Anchor(props) {
  let classes =
    'font-museo font-w-600 text-primary transition-500 hover:underline hover:text-almost-black focus:underline focus:text-almost-black ' + props.classes;

  if (props.buttonType === 'primary') {
    classes =
      'mb-15 md:mb-0 py-15 px-30 w-full md:w-auto inline-block leading-12 text-12 font-normal font-mont-700 font-w-700 rounded uppercase tracking-1 text-center transition-all transition-500 bg-primary border-primary border-solid border-1 hover:bg-almost-black hover:border-almost-black focus:bg-almost-black focus:border-almost-black text-white ' +
      props.classes;
  } else if (props.buttonType === 'secondary') {
    classes =
      'mb-15 md:mb-0 py-15 px-30 w-full md:w-auto inline-block leading-12 text-12 font-normal font-mont-700 font-w-700 rounded uppercase tracking-1 text-center transition-all transition-500 bg-white border-primary border-solid border-1 text-primary hover:border-almost-black hover:text-almost-black focus:border-almost-black focus:text-almost-black ' +
      props.classes;
  } else if (props.buttonType === 'tertiary') {
    classes =
      'mb-15 md:mb-0 py-15 px-30 w-full md:w-auto inline-block leading-12 text-12 font-normal font-mont-700 font-w-700 rounded uppercase tracking-1 text-center transition-all transition-500 bg-white border-white border-solid border-1 hover:text-almost-black focus:text-almost-black text-primary ' +
      props.classes;
  }

  return (
    <a className={classes} href={props.href} aria-label={props.aria}>
      {props.children}
    </a>
  );
}

export default Anchor;
